export const tenantReservationsHeaders = [
  {
    text: "Type",
    value: "type"
  },
  {
    text: "Promotion Offered",
    value: "promotion.text"
  },
  {
    text: "Quoted Price",
    value: "quoted_price"
  },
  {
    text: "Move In Date",
    value: "move_in_date"
  },
  {
    text: "Next Follow Up",
    value: "followup_at"
  },
  {
    text: "Last Contact",
    value: "last_followup_at"
  },
  {
    text: "Date Created",
    value: "created_at"
  },
  {
    text: "Source",
    value: "customer_source"
  },
  {
    text: "Actions...",
    sortable: false,
    value: "actions"
  }
];
